import React from "react";

const SubscribersActions = ({ subscriber, status = "pending", isLoading = false, handleSubscriberData, onChangeStatus, deleteSubscriber})=>{
    if (status === "approved"){
        return (
            <div className="subscribers-actions">
                <button
                    title="Editar"
                    onClick={e => { handleSubscriberData(subscriber) }}
                    className="btn btn-sm btn-info btn-icon">
                    <i className="fas fa-edit"></i>
                </button>
                <button
                    title="Anular Aprobación"
                    onClick={e => { onChangeStatus(subscriber, "pending") }}
                    className="btn btn-sm btn-primary-indigo btn-icon">
                    <i className="fas fa-hourglass-half"></i>
                </button>
                <button
                    title="Eliminar"
                    onClick={e => { deleteSubscriber(subscriber) }}
                    className="btn btn-sm btn-danger btn-icon">
                    <i className="fas fa-trash"></i>
                </button>
            </div>
        )
    }

    if (status === "pending") {
        return (
            <div className="subscribers-actions">
                <button
                    title="Aprobar"
                    disabled={isLoading}
                    onClick={e => { onChangeStatus(subscriber, "approved") }}
                    className="btn btn-sm btn-success btn-icon">
                    <i className="fas fa-check"></i>
                </button>
                <button
                    title="Rechazar"
                    disabled={isLoading}
                    onClick={e => { onChangeStatus(subscriber, "rejected") }}
                    className="btn btn-sm btn-danger btn-icon">
                    <i className="fas fa-times"></i>
                </button>
                <button
                    title="Eliminar"
                    onClick={e => { deleteSubscriber(subscriber) }}
                    className="btn btn-sm btn-danger btn-icon">
                    <i className="fas fa-trash"></i>
                </button>
            </div>
        )
    }

    if (status === "rejected") {
        return (
            <div className="subscribers-actions">
                <button
                    title="Aprobar"
                    disabled={isLoading}
                    onClick={e => { onChangeStatus(subscriber, "approved") }}
                    className="btn btn-sm btn-success btn-icon">
                    <i className="fas fa-check"></i>
                </button>
                <button
                    title="Anular Aprobación"
                    onClick={e => { onChangeStatus(subscriber, "pending") }}
                    className="btn btn-sm btn-primary-indigo btn-icon">
                    <i className="fas fa-hourglass-half"></i>
                </button>
                <button
                    title="Eliminar"
                    onClick={e => { deleteSubscriber(subscriber) }}
                    className="btn btn-sm btn-danger btn-icon">
                    <i className="fas fa-trash"></i>
                </button>
            </div>
        )
    }

    return null;
}

export default SubscribersActions;